var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
const MONITORED_SITES = [
    {
        label: 'Main Site',
        url: 'https://arucard.duckdns.org/',
        image: '/assets/images/main.png',
        state: 'checking',
    },
    {
        label: 'Nextcloud',
        url: 'https://nextcloud.arucard.duckdns.org/',
        image: '/assets/images/nextcloud.svg',
        state: 'checking',
    },
    {
        label: 'PeerTube',
        url: 'https://peertube.arucard.duckdns.org/',
        image: '/assets/images/peertube.svg',
        state: 'checking',
    },
    {
        label: 'Jellyfin',
        url: 'https://jellyfin.arucard.duckdns.org/',
        image: '/assets/images/jellyfin.svg',
        state: 'checking',
    },
    {
        label: 'Speedtest',
        url: 'https://arucard.duckdns.org/speedtest',
        image: '/assets/images/librespeed.png',
        state: 'checking',
    },
];
let AppHome = class AppHome extends LitElement {
    constructor() {
        super(...arguments);
        this.sites = MONITORED_SITES;
        this.lastRefresh = '';
        this.updateAvailable = false;
        this.waitingServiceWorker = null;
        this.didReloadForUpdate = false;
        this.registrationLookupRetries = 0;
    }
    static { this.styles = css `
    :host {
      display: block;
      min-height: 100vh;
      padding: 24px;
      box-sizing: border-box;
    }

    .panel {
      width: min(100%, 64rem);
      margin: 0 auto;
      padding: 24px;
      box-sizing: border-box;
      border: 1px solid rgba(0, 0, 0, 0.08);
      border-radius: 20px;
      background: rgba(255, 255, 255, 0.8);
      color: #0f172a;
      box-shadow: 0 24px 60px rgba(15, 23, 42, 0.12);
      backdrop-filter: blur(14px);
    }

    h1 {
      margin: 0;
      font-size: clamp(2rem, 4vw, 3rem);
      line-height: 1.1;
      color: inherit;
    }

    .title-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
    }

    .meta {
      margin-top: 18px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      color: #64748b;
      font-size: 0.82rem;
    }

    .update-link {
      margin-left: auto;
      color: inherit;
      text-decoration: underline;
      text-underline-offset: 2px;
      white-space: nowrap;
    }

    .update-link:focus-visible {
      outline: 2px solid #2563eb;
      outline-offset: 2px;
    }

    .refresh-button {
      border: 1px solid rgba(148, 163, 184, 0.28);
      border-radius: 999px;
      width: 2.65rem;
      height: 2.65rem;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      background: linear-gradient(180deg, rgba(30, 41, 59, 0.96), rgba(15, 23, 42, 0.96));
      color: #e2e8f0;
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08), 0 10px 24px rgba(15, 23, 42, 0.28);
      font: inherit;
      cursor: pointer;
      transition: transform 140ms ease, box-shadow 140ms ease, border-color 140ms ease,
        background 140ms ease;
    }

    .refresh-button svg {
      color: lightgrey;
    }

    .refresh-button:hover {
      border-color: rgba(148, 163, 184, 0.42);
      background: linear-gradient(180deg, rgba(51, 65, 85, 0.98), rgba(15, 23, 42, 0.98));
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1), 0 14px 28px rgba(15, 23, 42, 0.34);
      transform: translateY(-1px);
    }

    .refresh-button:active {
      transform: translateY(0);
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06), 0 8px 18px rgba(15, 23, 42, 0.24);
    }

    .refresh-button:focus-visible {
      outline: 2px solid #93c5fd;
      outline-offset: 3px;
    }

    .list {
      margin-top: 18px;
      display: grid;
      grid-template-columns: 1fr;
      gap: 10px;
    }

    .card {
      border-radius: 14px;
      border: 1px solid rgba(148, 163, 184, 0.25);
      background: rgba(248, 250, 252, 0.9);
      padding: 14px 16px;
    }

    .card-head {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      min-width: 0;
    }

    .card-title {
      display: flex;
      align-items: center;
      gap: 12px;
      min-width: 0;
    }

    .image-link {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 44px;
      width: 44px;
      height: 44px;
      align-self: center;
      border-radius: 10px;
      text-decoration: none;
      overflow: hidden;
    }

    .image-link:focus-visible,
    .service-link:focus-visible,
    .service-url:focus-visible {
      outline: 2px solid #2563eb;
      outline-offset: 2px;
    }

    .service-image {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
      border-radius: 8px;
    }

    h2 {
      margin: 0;
      font-size: 1rem;
    }

    .details {
      display: flex;
      flex-direction: column;
      gap: 2px;
      min-width: 0;
    }

    .service-link {
      color: inherit;
      text-decoration: none;
    }

    .service-link:hover h2,
    .service-url:hover {
      text-decoration: underline;
    }

    .service-url {
      display: block;
      color: #64748b;
      font-size: clamp(0.55rem, 2.2vw, 0.82rem);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: clip;
      text-decoration: none;
    }

    .status {
      display: inline-flex;
      flex: 0 0 auto;
      align-items: center;
      justify-content: center;
      min-width: 72px;
      padding: 0.25rem 0.55rem;
      border-radius: 999px;
      font-size: 0.72rem;
      font-weight: 700;
      letter-spacing: 0.04em;
      text-transform: uppercase;
    }

    .status.reachable {
      background: rgba(34, 197, 94, 0.15);
      color: #166534;
    }

    .status.down {
      background: rgba(239, 68, 68, 0.15);
      color: #991b1b;
    }

    .status.checking {
      background: rgba(59, 130, 246, 0.14);
      color: #1d4ed8;
    }

    @media (max-width: 640px) {
      :host {
        padding: 0;
      }

      .panel {
        width: 100%;
        min-height: 100vh;
        margin: 0;
        padding: 16px;
        border: 0;
        border-radius: 0;
        background: rgba(255, 255, 255, 0.8);
        box-shadow: none;
        backdrop-filter: none;
      }

      .title-row {
        align-items: center;
      }

      h1 {
        font-size: 1.6rem;
      }

      .card-head {
        display: grid;
        grid-template-columns: minmax(0, 1fr) auto;
        align-items: start;
        min-width: 0;
        gap: 10px;
      }

      .card {
        padding: 12px;
      }

      .card-title {
        width: auto;
        min-width: 0;
        gap: 10px;
      }

      .image-link {
        flex-basis: 40px;
        width: 40px;
        height: 40px;
        border-radius: 8px;
      }

      .details {
        gap: 4px;
      }

      h2 {
        font-size: 0.95rem;
      }

      .service-url {
        line-height: 1.35;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: clip;
      }

      .status {
        min-width: 64px;
        padding: 0.2rem 0.5rem;
        align-self: start;
      }

      .refresh-button {
        flex: 0 0 auto;
      }
    }

    @media (prefers-color-scheme: dark) {
      .panel {
        border-color: rgba(255, 255, 255, 0.1);
        background: rgba(15, 23, 42, 0.78);
        color: #e5e7eb;
        box-shadow: 0 24px 60px rgba(2, 6, 23, 0.45);
      }

      .meta {
        color: #cbd5e1;
      }

      .card {
        border-color: rgba(148, 163, 184, 0.18);
        background: rgba(15, 23, 42, 0.86);
      }

      .service-url {
        color: #cbd5e1;
      }

      .status.reachable {
        color: #86efac;
      }

      .status.down {
        color: #fca5a5;
      }

      .status.checking {
        color: #93c5fd;
      }

      .refresh-button {
        border-color: rgba(148, 163, 184, 0.22);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04), 0 12px 28px rgba(2, 6, 23, 0.4);
      }

      .refresh-button:hover {
        border-color: rgba(148, 163, 184, 0.34);
        box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08), 0 16px 32px rgba(2, 6, 23, 0.48);
      }
    }
  `; }
    connectedCallback() {
        super.connectedCallback();
        this.stopRefreshTimer();
        void this.refreshStatuses();
        this.refreshTimer = window.setInterval(() => {
            void this.refreshStatuses();
        }, 60000);
        if ('serviceWorker' in navigator) {
            if (document.readyState === 'complete') {
                void this.initializeServiceWorkerUpdates();
            }
            else {
                window.addEventListener('load', () => {
                    void this.initializeServiceWorkerUpdates();
                }, { once: true });
            }
        }
    }
    disconnectedCallback() {
        this.stopRefreshTimer();
        this.detachServiceWorkerListeners();
        super.disconnectedCallback();
    }
    async initializeServiceWorkerUpdates() {
        try {
            const registration = await navigator.serviceWorker.getRegistration('/');
            if (!registration) {
                if (this.registrationLookupRetries < 5) {
                    this.registrationLookupRetries += 1;
                    window.setTimeout(() => {
                        void this.initializeServiceWorkerUpdates();
                    }, 400);
                }
                return;
            }
            this.registrationLookupRetries = 0;
            this.attachServiceWorkerListeners(registration);
            if (registration.waiting) {
                this.setWaitingServiceWorker(registration.waiting);
            }
            void registration.update();
        }
        catch {
            // Ignore update wiring failures and keep normal dashboard behavior.
        }
    }
    attachServiceWorkerListeners(registration) {
        this.detachServiceWorkerListeners();
        this.updateRegistration = registration;
        this.registrationUpdateFoundHandler = () => {
            const installing = registration.installing;
            if (!installing) {
                return;
            }
            installing.addEventListener('statechange', () => {
                if (installing.state === 'installed' && navigator.serviceWorker.controller) {
                    this.setWaitingServiceWorker(registration.waiting ?? installing);
                }
            });
        };
        registration.addEventListener('updatefound', this.registrationUpdateFoundHandler);
        this.controllerChangeHandler = () => {
            if (this.didReloadForUpdate) {
                return;
            }
            this.didReloadForUpdate = true;
            window.location.reload();
        };
        navigator.serviceWorker.addEventListener('controllerchange', this.controllerChangeHandler);
    }
    detachServiceWorkerListeners() {
        if (this.updateRegistration && this.registrationUpdateFoundHandler) {
            this.updateRegistration.removeEventListener('updatefound', this.registrationUpdateFoundHandler);
        }
        if (this.controllerChangeHandler && 'serviceWorker' in navigator) {
            navigator.serviceWorker.removeEventListener('controllerchange', this.controllerChangeHandler);
        }
        this.registrationUpdateFoundHandler = undefined;
        this.controllerChangeHandler = undefined;
        this.updateRegistration = undefined;
    }
    setWaitingServiceWorker(worker) {
        this.waitingServiceWorker = worker;
        this.updateAvailable = true;
    }
    applyUpdate(event) {
        event.preventDefault();
        this.waitingServiceWorker?.postMessage({ type: 'SKIP_WAITING' });
    }
    stopRefreshTimer() {
        if (this.refreshTimer !== undefined) {
            window.clearInterval(this.refreshTimer);
            this.refreshTimer = undefined;
        }
    }
    async refreshStatuses() {
        this.sites = this.sites.map((site) => ({
            ...site,
            state: 'checking',
        }));
        const results = await Promise.all(this.sites.map(async (site) => ({
            ...site,
            state: await this.probeSite(site.url),
        })));
        this.sites = results;
        this.lastRefresh = new Date().toLocaleTimeString();
    }
    async probeSite(url) {
        const maxAttempts = 3;
        for (let attempt = 0; attempt < maxAttempts; attempt++) {
            const { signal, cleanup } = this.createTimeoutSignal(8000);
            try {
                const target = new URL(url);
                target.searchParams.set('_probe', Date.now().toString());
                // no-cors yields an opaque response, which is still enough to treat the host as reachable.
                await fetch(target.toString(), {
                    method: 'GET',
                    mode: 'no-cors',
                    cache: 'no-store',
                    signal,
                });
                return 'reachable';
            }
            catch (error) {
                // Exponential backoff before retry: 100ms, 200ms, 400ms
                if (attempt < maxAttempts - 1) {
                    const delayMs = Math.pow(2, attempt) * 100;
                    await new Promise(resolve => window.setTimeout(resolve, delayMs));
                }
            }
            finally {
                cleanup();
            }
        }
        return 'down';
    }
    createTimeoutSignal(timeoutMs) {
        if (typeof AbortSignal.timeout === 'function') {
            return {
                signal: AbortSignal.timeout(timeoutMs),
                cleanup: () => undefined,
            };
        }
        const controller = new AbortController();
        const timeoutId = window.setTimeout(() => controller.abort(), timeoutMs);
        return {
            signal: controller.signal,
            cleanup: () => window.clearTimeout(timeoutId),
        };
    }
    renderStatusLabel(state) {
        if (state === 'reachable') {
            return 'Reachable';
        }
        if (state === 'down') {
            return 'Down';
        }
        return 'Checking';
    }
    render() {
        return html `
      <section class="panel">
        <div class="title-row">
          <h1>Service Status</h1>
          <button
            class="refresh-button"
            @click=${this.refreshStatuses}
            aria-label="Refresh status list"
            title="Refresh status list"
          >
            <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
              <path
                fill="currentColor"
                d="M17.65 6.35A8 8 0 1 0 20 12h-2a6 6 0 1 1-1.76-4.24L13 11h7V4l-2.35 2.35Z"
              ></path>
            </svg>
          </button>
        </div>

        <div class="list">
          ${this.sites.map((site) => html `
              <article class="card">
                <div class="card-head">
                  <div class="card-title">
                    <a
                      class="image-link"
                      href=${site.url}
                      target="_blank"
                      rel="noreferrer"
                      aria-label=${`Open ${site.label}`}
                      title=${site.label}
                    >
                      <img class="service-image" src=${site.image} alt="" />
                    </a>
                    <div class="details">
                      <a
                        class="service-link"
                        href=${site.url}
                        target="_blank"
                        rel="noreferrer"
                        aria-label=${`Open ${site.label}`}
                      >
                        <h2>${site.label}</h2>
                      </a>
                      <a
                        class="service-url"
                        href=${site.url}
                        target="_blank"
                        rel="noreferrer"
                        >${site.url}</a
                      >
                    </div>
                  </div>
                  <span class="status ${site.state}">${this.renderStatusLabel(site.state)}</span>
                </div>
              </article>
            `)}
        </div>

        <div class="meta">
          <span>${this.lastRefresh ? `Last checked at ${this.lastRefresh}` : 'Running first check...'}</span>
          ${this.updateAvailable
            ? html `<a class="update-link" href="#" @click=${this.applyUpdate}
                  >Update to ${__APP_VERSION__}</a
                >`
            : null}
        </div>
      </section>
    `;
    }
};
__decorate([
    state()
], AppHome.prototype, "sites", void 0);
__decorate([
    state()
], AppHome.prototype, "lastRefresh", void 0);
__decorate([
    state()
], AppHome.prototype, "updateAvailable", void 0);
AppHome = __decorate([
    customElement('app-home')
], AppHome);
export { AppHome };
